<div class="partner-view-card">
  <div class="image-holder">
  @if (partner?.file) {
    <img
      [src]="imagesUrl  + $safeNavigationMigration(partner?.file)"
      alt="Partner"
      loading="lazy"
      class="partner-image" />
  }
  </div>
  <div class="partner-content">
    <div class="partner-details">
      <div class="partner-title">{{ partner?.name }}</div>
    </div>
  </div>
</div>